import * as React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Redirect, NavLink } from "react-router-dom";

class Splitter extends React.Component<any, any> {
    render() {
        let { auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;
        if (auth.user.role == "artist") return <Redirect to="/user" />;
        if (auth.user.role == "producer") return <Redirect to="/producer" />;
        
        return <Redirect to="/admin" />;
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth
    };
})(Splitter);